import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const CyberFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. Do small businesses need cyber insurance?",
      answer: (
        <>
           <span style={{ color: "#F37435", fontWeight: "700"}}>Yes,</span> small businesses need cyber insurance. Cyber threats do not discriminate based on the size of a business. In fact, small businesses are often targeted because they may have less sophisticated security measures in place. Cyber insurance can help small businesses manage the financial impact of a cyber-attack.
        </>
      )
    },
    {
      question: "Q2. How is the cost of cyber insurance determined?",
      answer: (
        <>
        The cost of cyber insurance depends on several factors, including the <span style={{ color: "#F37435", fontWeight: "700"}}>size and type of your business, the amount of sensitive data you handle, your industry, your company's cyber security measures, and your claims history.</span>Premiums are tailored to reflect the specific risk profile of your business.
       </>
      )
    },
    {
      question: "Q3. What is business interruption coverage in cyber insurance?",
      answer:(
        <>
       Business interruption coverage in cyber insurance compensates for <span style={{ color: "#F37435", fontWeight: "700"}}>lost income and additional expenses incurred when a cyber incident disrupts normal business operations.</span> This can include costs related to lost revenue, expenses for temporary relocation, and payroll for employees during the interruption period.
      </>
      )
      },

      {
        question: "Q4. Does cyber insurance cover phishing attacks?",
        answer:(
          <>
          <span style={{ color: "#F37435", fontWeight: "700"}}>Cyber insurance can cover losses from phishing attacks,</span> which are common tactics used to gain unauthorized access to sensitive information. Coverage can include costs related to investigating the attack, notifying affected parties, and restoring compromised systems.
        </>
        )
        },
    {
      question: "Q5. Can Cyber Insurance be customized for specific industries?",
      answer: (
        <>
        <span style={{ color: "#F37435", fontWeight: "700"}}>Yes,</span> Cyber insurance can be tailored to meet the unique needs of different industries. Insurers offer specialized coverage options for sectors like healthcare, finance, retail, and manufacturing, each with specific risks and regulatory requirements.

        </>
      )
      
    
    },
    {
      question: "Q6. What is social engineering fraud coverage in cyber insurance?",
      answer: (
        <>
           Social engineering fraud coverage protects businesses from losses due to deceptive <span style={{ color: "#F37435", fontWeight: "700"}}>tactics used by cybercriminals to manipulate employees into divulging confidential information or transferring funds.</span>. This type of coverage can help mitigate the financial impact of such scams.
        </>
      )
      
    },
    {
      question: "Q7. Is cyber insurance required by law?",
      answer: (
      
       <>
      Cyber insurance is <span style={{ color: "#F37435", fontWeight: "700"}}>not typically required by law, but it is increasingly becoming a recommended best practice for businesses of all sizes.</span>. Some industries with stringent data protection regulations may strongly encourage or effectively mandate having cyber insurance to manage compliance risks.
        </>

      )
      
    },
   
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default CyberFAQ;